import { render } from "./NavLight.vue?vue&type=template&id=ebf763ae"
import script from "./NavLight.vue?vue&type=script&lang=js"
export * from "./NavLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__